import React, { Component } from 'react';
import Link from 'gatsby-link';
import { css } from 'emotion';
import { keyframes } from 'react-emotion';
import colors from '../../utils/colors';
import MobileNav from './mobile';
import media from '../../utils/media';
import feather from '../../utils/feather';
import { Box } from '../../components/Layout';
import palloSiluetti from '../../assets/images/pallo_siluetti.svg';

const basicNav = css`
  overflow: visible;
  display: flex;
  position: fixed;
  top: 0;
  align-items: center;
  color: ${colors.primary};
  background-image: linear-gradient(to right, #fd635a, #f69616 50%, #f69616);
  margin: 0;
  width: 100%;
  list-style-type: none;
  -webkit-box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 1);
  -moz-box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 1);
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 1);
  z-index: 9998;
  height: 3.5rem;

  .layer {
    background-color: ${colors.nav};
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  & ul {
    list-style-type: none;
    display: flex;
    margin: 0;
    padding: 0;
    width: 100%;
    & li a {
      white-space: nowrap;
      line-height: normal;
    }
  }
`;

const fullNav = css`
  ${basicNav};
  display: none;
  & li {
    margin: 0;
  }

  & li img {
    display: inline-block;
    vertical-align: middle;
  }
  & ul div {
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
    margin-right: auto;

    & li {
      margin-left: 1.25rem;
    }
  }

  ${media.mid`
    display: flex;
  `};
`;

// Styles for the mobile View of the navigation
const mobileNav = css`
  ${basicNav};
  & li {
    margin: 0;
  }

  & li:last-child {
    margin-left: auto;
    font-weight: 600;
    cursor: pointer;
  }

  & li img {
    display: block;
    margin: auto;
  }
  ${media.mid`
    display: none;
  `};
`;

// Styles for the overlay which pops up, when the menu is clicked
const mobileStyle = css`
  position: fixed;
  color: ${colors.primary};
  background-image: linear-gradient(to right, #fd635a, #f69616 50%, #f69616);
  display: block;
  padding: 1rem;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  overflow: scroll;

  & ul {
    list-style-type: none;
    padding: 0;
    margin: 3rem 0 0 0;
    height: 100%;
    text-align: center;
    font-size: 2rem;
    & div {
      text-align: center;
    }
  }

  & ul li {
    margin-top: 2rem;
  }
  & div {
    font-weight: 600;
    text-align: right;
  }
  .layer {
    background-color: ${colors.nav};
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const svgStyles = css`
  opacity: 0.5;
  transition: opacity 0.15s ease-in;
  transition: color 0.15s ease-in;

  &:hover {
    text-decoration: none;
    box-shadow: none;
    opacity: 1;
    transition: opacity 0.15s ease-in;
  }
`;

const sway = keyframes`
	0% {
		transform: rotate(10deg);
  }
  50% {
    transform: rotate(-10deg);
  }
  100% {
    transform: rotate(10deg);
  }
`;

const fadein = keyframes`
  0% { opacity 0;}
  75% { opacity 0;}
  100% { opacity 1;}
`;

const palloStyleNav = css`
  :after {
    content: '      ';
    opacity: 1;
    display: block;
    position: absolute;
    top: 0.5em;
    bottom: 0;
    left: 1em;
    width: 4em;
    height: 4em;
    z-index: 100;
    background: url(${palloSiluetti}) no-repeat right 50%;
    animation: ${sway} 5s ease-in-out infinite, ${fadein} 10s ease-in 1;
    transform-origin: 70% 15%;
    ${media.mid`
      width: 4em;
      height: 4em;
    `};
    ${media.small`
      width: 3em;
      height: 3em;
    `};
  }
`;

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileActive: false
    };
    this.toggleNav = this.toggleNav.bind(this);
  }

  toggleNav() {
    if (this.state.mobileActive) {
      this.setState({ mobileActive: false });
    } else {
      this.setState({ mobileActive: true });
    }
  }

  render() {
    const some = {
      name: 'Owla ja kadonnut walkia',
      facebook: 'https://www.facebook.com/owlatanssiseikkailu/',
      instagram: 'https://www.instagram.com/owlatanssiseikkailu/'
    };

    const pallo = <div className={palloStyleNav} />;

    return (
      <nav>
        <Box width="100%" px={[3, 3, 4]} className={fullNav}>
          <div className="layer" />
          <ul>
            <div>
              <li>
                <Link to="/">{pallo}</Link>
              </li>
              <li>
                <Link to="/teoksesta">Teoksesta</Link>
              </li>
              <li>
                <Link to="/tekijat">Tekijät</Link>
              </li>
              <li>
                <Link to="/esiintyjat">Esiintyjät</Link>
              </li>
              <li>
                <Link to="/naytokset">Näytökset</Link>
              </li>
              <li>
                <Link to="/liput">Liput</Link>
              </li>
              <li>
                <Link to="/yhteistyossa">Yhteistyössä</Link>
              </li>
              <li>
                <Link to="/english">In English</Link>
              </li>
              <li>
                <Link
                  title="Link to our Facebook page"
                  href={some.facebook}
                  target="_blank"
                  rel="noopener"
                >
                  {feather('facebook', ['30', '30'], svgStyles)}
                </Link>
              </li>
              <li>
                <Link
                  title="Link to out Instragram account"
                  href={some.instagram}
                  target="_blank"
                  rel="noopener"
                >
                  {feather('instagram', ['30', '30'], svgStyles)}
                </Link>
              </li>
            </div>
          </ul>
        </Box>
        <Box width="100%" px={[3, 3, 4]} className={mobileNav}>
          <div className="layer" />
          <ul>
            <li>
              <Link to="/">{pallo}</Link>
            </li>
            <li>
              <div
                onClick={this.toggleNav}
                role="button"
                tabIndex="0"
                onKeyPress={this.toggleNav}
              >
                MENU
              </div>
            </li>
          </ul>
        </Box>
        {this.state.mobileActive && (
          <MobileNav toggleNav={this.toggleNav} mobileStyle={mobileStyle}>
            <ul>
              <li>
                <div
                  onClick={this.toggleNav}
                  role="button"
                  tabIndex="0"
                  onKeyPress={this.toggleNav}
                >
                  <Link to="/">Owla</Link>
                </div>
              </li>
              <li>
                <div
                  onClick={this.toggleNav}
                  role="button"
                  tabIndex="-1"
                  onKeyPress={this.toggleNav}
                >
                  <Link to="/teoksesta">Teoksesta</Link>
                </div>
              </li>
              <li>
                <div
                  onClick={this.toggleNav}
                  role="button"
                  tabIndex="-1"
                  onKeyPress={this.toggleNav}
                >
                  <Link to="/tekijat">Tekijät</Link>
                </div>
              </li>
              <li>
                <div
                  onClick={this.toggleNav}
                  role="button"
                  tabIndex="-1"
                  onKeyPress={this.toggleNav}
                >
                  <Link to="/esiintyjat">Esiintyjät</Link>
                </div>
              </li>
              <li>
                <div
                  onClick={this.toggleNav}
                  role="button"
                  tabIndex="-1"
                  onKeyPress={this.toggleNav}
                >
                  <Link to="/naytokset">Näytökset</Link>
                </div>
              </li>
              <li>
                <div
                  onClick={this.toggleNav}
                  role="button"
                  tabIndex="-1"
                  onKeyPress={this.toggleNav}
                >
                  <Link to="/liput">Liput</Link>
                </div>
              </li>
              <li>
                <div
                  onClick={this.toggleNav}
                  role="button"
                  tabIndex="-1"
                  onKeyPress={this.toggleNav}
                >
                  <Link to="/yhteistyossa">Yhteistyössä</Link>
                </div>
              </li>
              <li>
                <div
                  onClick={this.toggleNav}
                  role="button"
                  tabIndex="-1"
                  onKeyPress={this.toggleNav}
                >
                  <Link to="/english">In English</Link>
                </div>
              </li>
              <li>
                <Link
                  title="Link to our Facebook page"
                  href={some.facebook}
                  target="_blank"
                  rel="noopener"
                >
                  {feather('facebook', ['30', '30'], svgStyles)}
                </Link>
              </li>
              <li>
                <Link
                  title="Link to out Instragram account"
                  href={some.instagram}
                  target="_blank"
                  rel="noopener"
                >
                  {feather('instagram', ['30', '30'], svgStyles)}
                </Link>
              </li>
            </ul>
          </MobileNav>
        )}
      </nav>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js